import { BdcShipmentDetail } from "../../../types/bdc.type";
import { picklistMatches } from "../controlSheet";
import { baht, pcs } from "../format";
import Tag from "../Tag";

/** สรุปสินค้า (Bulk) — one row per SKU of the PO; cases come from the backend's pcs_per_case. */
export default function BulkTable({ detail }: Readonly<{ detail: BdcShipmentDetail }>) {
  const { header, items } = detail;
  const isX = header.kind === "X";
  return (
    <table className="bdc-t">
      <thead>
        <tr>
          <th>รหัส 7-11</th>
          <th>Barcode</th>
          <th>สินค้า</th>
          <th>ขนาด</th>
          <th className="n">ชิ้น/ลัง</th>
          <th className="n">ชิ้น</th>
          <th className="n">ลังเต็ม</th>
          <th className="n">เศษ</th>
          <th className="n">ราคา/ชิ้น</th>
          <th className="n">ยอดเงิน</th>
          {!isX && <th className="c">รายร้าน</th>}
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.barcode}>
            <td className="mono">{item.item_code}</td>
            <td className="mono">{item.barcode}</td>
            <td>
              {item.name}
              {item.product_code && <span className="sub"> · GB {item.product_code}</span>}
            </td>
            <td className="sub">{item.size ?? ""}</td>
            <td className="n sub">{item.pcs_per_case}</td>
            <td className="n">
              <b>{pcs(item.qty)}</b>
            </td>
            <td className="n">{pcs(item.full_cases)}</td>
            <td className="n">{pcs(item.remainder)}</td>
            <td className="n">{baht(item.unit_price)}</td>
            <td className="n">{baht(item.amount)}</td>
            {!isX && (
              <td className="c">
                {picklistMatches(item) ? (
                  <Tag tone="ok">✓</Tag>
                ) : (
                  <Tag tone="crit">{pcs(item.picklist_qty ?? 0)}</Tag>
                )}
              </td>
            )}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={5}>รวม {items.length} SKU</td>
          <td className="n">{pcs(header.pieces)}</td>
          <td className="n">{pcs(header.full_cases)}</td>
          <td />
          <td />
          <td className="n">{baht(header.subtotal)}</td>
          {!isX && <td />}
        </tr>
      </tfoot>
    </table>
  );
}
